import React, { FunctionComponent, ReactNode } from 'react';
import {
  FormControlLabel,
  Checkbox as MuiCheckbox,
  FormControl,
  FormHelperText
} from '@mui/material';
import cx from 'classnames';
import styles from './Checkbox.styles';
import useStyles from './Checkbox.styles';

interface IProps {
  id: string;
  name: string;
  checked: boolean;
  customClass?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  errorMessage?: string;
  content: ReactNode;
  hideErrorMessage?: boolean;
};

const Checkbox: FunctionComponent<IProps> = ({
  id,
  name,
  customClass = '',
  checked,
  onChange,
  label,
  errorMessage,
  hideErrorMessage,
  content
}) => {
  const classes = useStyles()
  return (
    <FormControl fullWidth className={cx({ [customClass]: customClass } )}>
      <div className={classes.header}>
        <label
          className={cx(classes.label, {
            [classes.labelError]: errorMessage,
          })}
          htmlFor={id}
          data-testid={`test-${id}__checkbox__label`}
        >
          {label}
        </label>
      </div>
      <FormControlLabel
        control={
          <MuiCheckbox name={name} checked={checked} onChange={onChange} color="primary" />
        }
        label={content}
      />
      {!hideErrorMessage && errorMessage && (
        <FormHelperText
          classes={{ root: classes.error }}
          error
          data-testid={`test-${id}__checkbox__error-message`}
        >
          {errorMessage}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default Checkbox;
